module.exports = __webpack_public_path__ + "img/pic03.056bf5ad.png";